<app-abandoned-reservation-header
  [user]="user"
  [translationType]="'FLIGHTS'">
</app-abandoned-reservation-header>
<app-abandoned-reservation-body [hasImage]="hasImage">
  <app-image
    image
    [type]="typeImage"
    [src]="reservationImageByDestination"
    [maxHeight]="181"
    [borderRadius]="8"
    (errorImage)="errorImage($event)"
    >
  </app-image>
  <ng-container content>
    <div class="abandonedFlightItinerary__header">
      <div class="abandonedFlightItinerary__header--box">
        <strong *ngIf="arrivalAirportCode"> {{ arrivalAirportCode | placeName | async | capitalizeAll}}</strong>
        <app-small-reservation-date-info [sectors]="sectors"></app-small-reservation-date-info>
      </div>
    </div>
    <div class="abandonedFlightItinerary__body">
      <ng-container *ngFor="let sector of sectors">
        <app-simple-travel-summary
          [options]="[sector]"
          [summaryProvider]="summaryProvider"
          [type]="sector.SectorNumber">
        </app-simple-travel-summary>
      </ng-container>
    </div>
    <div *ngIf="assistanceItem" class="abandonedFlightItinerary__assistance">
      <div class="abandonedFlightItinerary__assistance--img">
        <div class="image" [ngStyle]="backgroundAssistanceImageByItem(IMAGE | baseImage: BASE_PATH)"></div>
      </div>
      <div class="abandonedFlightItinerary__assistance--description">
        <span> {{ assistanceItem?.BookingSource | uppercase}} • {{'USER_HISTORY_MODULE.RESERVATION_ITEM_ASSISTANCE.ASSISTANCE_TYPE' | transloco}}</span>
      </div>
    </div>
    <app-abandoned-reservation-actions
      [itineraryId]="itinerary?.Id"
      [reservationType]="reservationType"
      [userId]="user?.id"
      [isMobile]="isMobile"
      [isLoadingCancellation]="isLoadingCancellation"
      (cancelEvent)="cancelEvent.emit(airReservationItem?.Id)">
    </app-abandoned-reservation-actions>
  </ng-container>
</app-abandoned-reservation-body>